<template>
<div>

  <VueBotUI :messages="data" :options="botOptions" @init="botStart" @msg-send="messageSendHandler" :input-disable="true" />
  <div>1234567</div>
</div>
    
  
</template>

<script>
import '@/config/remmobile'
import { VueBotUI } from "vue-bot-ui";

export default {
data(){
  return{
 data: [
        {
          agent: "bot", // 必需。'bot' 或 'user'
          type: "bubbleButton", // 必需。气泡消息组件类型：'text' / 'button'
          text: "Hello. 我有什么可以帮助你的", // 必需的。消息
          disableInput: true // 是否禁用消息输入
        },
        {
          agent: "bot",
          type: "button",
          text: "You have questions, we have answers 😊 How can I help?",
          options: [
            {
              text: "I would like a research consultation",
              action: "postback"
            },
            {
              text: "I would like a consultation with an industry expert",
              action: "postback"
            },
            {
              text: "I would like to be a partner supplier",
              value: "contact?source=robot"
            },
            {
              text: "Feedback",
              value: "contact?source=robot"
            }
          ]
        }
      ], //消息数据
  }
},
components: {
    VueBotUI
  },
}
</script>

<style>

</style>